<div class="rating">
  @for (item of starArray; track $index; let i = $index) {
  <div [class]="`rating-label me-${gapMargin} checked`" [ngbTooltip]="`${i +1} คะแนน`">
    <i (click)="selectStar(i + 1)" [class]="`bi ${iconSize}`" [ngClass]="{
        'bi-star-fill': i + 1 <= rating,
        'bi-star': i + 1 > rating,
        'cursor-pointer': modeForm
      }"></i>
  </div>
  }
</div>